<template>
	<div class="ui basic active tab">
		<div class="ui">
			<h1 class="header">
				{{ $t('pages.bookings.header') }}
			</h1>
		</div>

		<div class="ui divider"></div>

		<div class="ui two column grid">
			<!-- Available bookings module -->
			<available-bookings class="sixteen wide mobile six wide tablet six wide computer column"></available-bookings> 
			<!-- reserved-bookings -->
			<reserved-bookings class="sixteen wide mobile ten wide tablet ten wide computer column"></reserved-bookings>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Bookings',

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/merchant/Bookings.vue